import * as React from 'react';
import Helmet from 'react-helmet';
import {styled, mq} from '../../utils';
import LoginForm from '../../containers/LoginForm';
import {Main} from '../../components/AuthLayout';
import {margin} from 'polished';

const PageTitleWrapper = styled('div')({
  ...margin(20, 0, 30),
  [mq('laptop')]: {
    ...margin(25, 0, 30)
  },
  [mq('desktop')]: {
    ...margin(0, 0, 78)
  }
});

const PageTitle = styled('h1')(({theme}) => ({
  fontFamily: theme.fontFamily.base,
  fontSize: 38,
  marginBottom: 19,
  [mq('laptop')]: {
    fontSize: 42,
    marginBottom: 21
  },
  [mq('desktop')]: {
    fontSize: 50,
    marginBottom: 25
  }
}));

const PageSubtitle = styled('p')(({theme}) => ({
  fontFamily: theme.fontFamily.base,
  fontSize: 16,
  fontWeight: 300,
  color: '#7E8DA6'
}));

export default class Login extends React.Component<{}, {}> {
  public render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Login to Admin</title>
        </Helmet>

        <Main narrow={true}>
          <PageTitleWrapper>
            <PageTitle>Admin Dashboard</PageTitle>
            <PageSubtitle>Enter your details below</PageSubtitle>
          </PageTitleWrapper>
          <LoginForm />
        </Main>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Login/Login.tsx